/* INFINTOS — Spring-Engine und Direktmanipulation.
   Nach jedem Section-Neuaufbau im Theme-Editor erneut initialisiert. */

;
function infintosBoot(){
'use strict';

var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ==================================================================
   SPRING §4 — Damping-Ratio + Response, wie Apple sie denkt.
   Kein CSS-transition, kein @keyframes: interruptierbar (§3),
   startet immer vom Presentation Value, trägt Velocity mit.
================================================================== */
function Spring(value, opts){
  opts = opts || {};
  this.x = value; this.target = value; this.v = 0;
  this.setParams(opts.damping != null ? opts.damping : 1.0,
                 opts.response != null ? opts.response : 0.35);
  this.onUpdate = opts.onUpdate || function(){};
  this.running = false; this.last = 0;
}
Spring.prototype.setParams = function(damping, response){
  this.zeta = damping;
  this.omega = (2 * Math.PI) / response;   // §4 Response = Zeit bis Ziel, nicht Dauer
};
Spring.prototype.to = function(target, velocity){
  this.target = target;
  if (velocity != null) this.v = velocity;   // §5 Velocity-Handoff
  if (REDUCE){ this.x = target; this.v = 0; this.onUpdate(this.x); return; }
  this.start();
};
Spring.prototype.set = function(x){ this.x = x; this.v = 0; this.onUpdate(x); };
Spring.prototype.start = function(){
  if (this.running) return;
  this.running = true; this.last = performance.now();
  var self = this;
  requestAnimationFrame(function step(now){          // §11 rAF als Display-Takt
    var dt = Math.min((now - self.last) / 1000, 1/30);
    self.last = now;
    var d = self.x - self.target;
    var a = (-self.omega * self.omega * d) - (2 * self.zeta * self.omega * self.v);
    self.v += a * dt;
    self.x += self.v * dt;
    self.onUpdate(self.x);
    if (Math.abs(self.x - self.target) < 0.0008 && Math.abs(self.v) < 0.0015){
      self.x = self.target; self.v = 0; self.onUpdate(self.x);
      self.running = false; return;
    }
    requestAnimationFrame(step);
  });
};

/* §6 Apples Projektionsfunktion — exponentieller Zerfall, nicht v²/2a */
function project(v, rate){
  rate = rate == null ? 0.998 : rate;
  return (v / 1000) * rate / (1 - rate);
}
/* §9 Rubberband — progressiver Widerstand statt harter Kante */
function rubberband(over, dim, c){
  c = c == null ? 0.55 : c;
  return (over * dim * c) / (dim + c * Math.abs(over));
}

/* ==================================================================
   PRESS §1 — Feedback beim Runterdrücken, nicht beim Loslassen.
   §10 — 10px Hysterese, Abbruch durch Wegziehen und wieder zurück.
================================================================== */
document.querySelectorAll('[data-press]').forEach(function(el){
  var s = new Spring(1, { damping: 1.0, response: 0.28, onUpdate: function(v){
    el.style.transform = 'scale(' + v + ')';
  }});
  var id = null, sx = 0, sy = 0, out = false;
  el.style.transformOrigin = 'center';            // §7 Origin am Auslöser

  el.addEventListener('pointerdown', function(e){
    id = e.pointerId; sx = e.clientX; sy = e.clientY; out = false;
    if (el.tagName !== 'BUTTON') el.setPointerCapture(id);   // §2 Tracking über die Grenzen hinaus
    s.to(0.97);                                    // sofort, nicht erst bei pointerup
  });
  el.addEventListener('pointermove', function(e){
    if (id === null || e.pointerId !== id) return;
    var far = Math.hypot(e.clientX - sx, e.clientY - sy) > 10;
    if (far !== out){ out = far; s.to(out ? 1 : 0.97); }  // wegziehen = abbrechen, zurück = wieder gedrückt
  });
  function release(){
    if (id === null) return;
    try { el.releasePointerCapture(id); } catch (err) {}
    id = null; s.to(1);
  }
  el.addEventListener('pointerup', release);
  el.addEventListener('pointercancel', release);
  el.addEventListener('lostpointercapture', release);
});

/* Pfeil im Textlink folgt dem Zeiger — Hinweis in Gestenrichtung §8 */
document.querySelectorAll('.ifs-linkish').forEach(function(el){
  var arw = el.querySelector('.ifs-arw'); if (!arw) return;
  var s = new Spring(0, { damping: 1.0, response: 0.35, onUpdate: function(v){
    arw.style.transform = 'translateX(' + v + 'px)';
  }});
  el.addEventListener('pointerenter', function(){ s.to(6); });
  el.addEventListener('pointerleave', function(){ s.to(0); });
});

/* Produktbild atmet beim Überfahren */
document.querySelectorAll('[data-zoom]').forEach(function(img){
  var s = new Spring(1, { damping: 1.0, response: 0.4, onUpdate: function(v){
    img.style.transform = 'scale(' + v + ')';
  }});
  var fig = img.closest('figure');
  fig.addEventListener('pointerenter', function(){ s.to(1.04); });
  fig.addEventListener('pointerleave', function(){ s.to(1); });
});

/* ==================================================================
   NAVIGATION — Glas materialisiert (§12: Blur und Scale zusammen)
================================================================== */
(function(){
  var mat = document.getElementById('navMat'), edge = document.getElementById('navEdge');
  var on = false;
  var s = new Spring(0, { damping: 1.0, response: 0.4, onUpdate: function(v){
    mat.style.opacity = v;
    mat.style.transform = 'scaleY(' + (0.92 + 0.08 * v) + ')';
    edge.style.opacity = v;
    document.documentElement.style.setProperty('--ifs-glass-blur', (8 + 12 * v) + 'px');
  }});
  addEventListener('scroll', function(){
    var want = scrollY > 24;
    if (want !== on){ on = want; s.to(on ? 1 : 0); }
  }, { passive: true });
})();

/* ==================================================================
   GALERIE — Autoplay + Direktmanipulation
   Desktop: Spring-Slider.
   Touch: natives Swipen/Scroll-Snap.
================================================================== */
(function(){
  var view = document.getElementById('galView');
  var track = document.getElementById('galTrack');
  var dotsBox = document.getElementById('galDots');
  if (!view || !track || !dotsBox || view.dataset.bound) return;

  view.dataset.bound = '1';

  var root = view.closest('.ifs-gal');
  var slides = [].slice.call(track.children);
  if (!slides.length) return;

  var autoplay = !root || root.dataset.galleryAutoplay !== 'false';
  var wait = parseInt(root && root.dataset.galleryInterval, 10) || 5000;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var index = 0;
  var timer = null;
  var interacting = false;

  function clearTimer(){
    if (timer){
      clearTimeout(timer);
      timer = null;
    }
  }

  function schedule(){
    clearTimer();
    if (!autoplay || reduce || interacting || document.hidden || slides.length < 2) return;
    timer = setTimeout(function(){
      goTo((index + 1) % slides.length, true);
    }, wait);
  }

  function setDots(){
    [].forEach.call(dotsBox.children, function(b, i){
      b.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }

  slides.forEach(function(_, i){
    var b = document.createElement('button');
    b.className = 'ifs-dot';
    b.type = 'button';
    b.setAttribute('aria-label', 'Bild ' + (i + 1));
    b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
    b.addEventListener('click', function(){
      goTo(i, true);
    });
    dotsBox.appendChild(b);
  });

  var isTouch = matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;

  /* ---------------- Touch / Mobile ---------------- */
  if (isTouch){
    view.classList.add('ifs-native');

    function mobileLeft(i){
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      return Math.max(0, slides[i].offsetLeft - pad);
    }

    function goMobile(i, smooth){
      index = (i + slides.length) % slides.length;
      view.scrollTo({
        left: mobileLeft(index),
        behavior: smooth && !reduce ? 'smooth' : 'auto'
      });
      setDots();
      schedule();
    }

    window.goTo = window.goTo || function(){};
    var goTo = goMobile;

    var scrollEndTimer = null;
    view.addEventListener('scroll', function(){
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(function(){
        var best = 0, bestDist = Infinity;
        var current = view.scrollLeft;
        slides.forEach(function(el, i){
          var d = Math.abs(mobileLeft(i) - current);
          if (d < bestDist){ bestDist = d; best = i; }
        });
        index = best;
        setDots();
        schedule();
      }, 90);
    }, {passive:true});

    view.addEventListener('touchstart', function(){
      interacting = true;
      clearTimer();
    }, {passive:true});

    view.addEventListener('touchend', function(){
      interacting = false;
      schedule();
    }, {passive:true});

    document.addEventListener('visibilitychange', function(){
      document.hidden ? clearTimer() : schedule();
    });

    goMobile(0, false);
    schedule();
    return;
  }

  /* ---------------- Desktop ---------------- */
  var minX = 0, maxX = 0, stops = [];

  var spring = new Spring(0, {
    damping: 1.0,
    response: 0.4,
    onUpdate: function(v){
      track.style.transform = 'translate3d(' + v + 'px,0,0)';
    }
  });

  function measure(){
    var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    stops = slides.map(function(el){ return -(el.offsetLeft - pad); });
    maxX = 0;
    minX = -(track.scrollWidth - view.clientWidth);
    if (minX > 0) minX = 0;
    goDesktop(Math.min(index, slides.length - 1), false);
  }

  function nearest(x){
    var best = 0, bestDist = Infinity;
    stops.forEach(function(p, i){
      var d = Math.abs(p - x);
      if (d < bestDist){ bestDist = d; best = i; }
    });
    return best;
  }

  function goDesktop(i, smooth, velocity){
    index = (i + slides.length) % slides.length;
    var target = Math.max(minX, Math.min(maxX, stops[index] || 0));
    spring.setParams(smooth ? 0.9 : 1.0, smooth ? 0.34 : 0.35);
    spring.to(target, velocity);
    setDots();
    schedule();
  }

  var goTo = goDesktop;

  var pointerId = null;
  var startX = 0;
  var startPos = 0;
  var hist = [];
  var axis = null;

  view.addEventListener('pointerdown', function(e){
    if (e.pointerType === 'mouse' && e.button !== 0) return;

    interacting = true;
    clearTimer();

    pointerId = e.pointerId;
    view.setPointerCapture(pointerId);
    startX = e.clientX;
    startPos = spring.x;
    spring.running = false;
    hist = [{x:e.clientX, t:performance.now()}];
    axis = null;
    view.classList.add('ifs-dragging');
  });

  view.addEventListener('pointermove', function(e){
    if (pointerId === null || e.pointerId !== pointerId) return;

    var dx = e.clientX - startX;
    if (axis === null){
      if (Math.abs(dx) < 10) return;
      axis = 'x';
    }

    var x = startPos + dx;
    if (x > maxX) x = maxX + rubberband(x - maxX, view.clientWidth);
    if (x < minX) x = minX + rubberband(x - minX, view.clientWidth);

    spring.set(x);
    hist.push({x:e.clientX, t:performance.now()});
    if (hist.length > 6) hist.shift();
  });

  function finish(){
    if (pointerId === null) return;

    pointerId = null;
    view.classList.remove('ifs-dragging');

    if (axis === 'x' && hist.length > 1){
      var a = hist[0], b = hist[hist.length - 1];
      var dt = (b.t - a.t) / 1000;
      var v = dt > 0 ? (b.x - a.x) / dt : 0;
      var projected = spring.x + project(v);
      index = nearest(projected);
      goDesktop(index, true, v);
    }

    interacting = false;
    schedule();
  }

  view.addEventListener('pointerup', finish);
  view.addEventListener('pointercancel', finish);
  view.addEventListener('lostpointercapture', finish);

  document.addEventListener('visibilitychange', function(){
    document.hidden ? clearTimer() : schedule();
  });

  addEventListener('resize', measure);
  addEventListener('load', measure);
  measure();
  schedule();
})();

/* ==================================================================
   FRAGEN — Spring auf der Panelhöhe, Inhalt über transform/opacity.
   Ein- und Ausweg identisch §7.
================================================================== */
document.querySelectorAll('.ifs-qa').forEach(function(qa){
  var btn = qa.querySelector('.ifs-qa__btn');
  var panel = qa.querySelector('.ifs-qa__panel');
  var inner = qa.querySelector('.ifs-qa__inner');
  var sign = qa.querySelector('.ifs-qa__sign');
  var open = false;

  var h = new Spring(0, { damping: 1.0, response: 0.35, onUpdate: function(v){
    panel.style.height = v + 'px';
  }});
  var f = new Spring(0, { damping: 1.0, response: 0.35, onUpdate: function(v){
    inner.style.opacity = v;
    inner.style.transform = 'translateY(' + ((1 - v) * 8) + 'px)';
  }});
  var r = new Spring(0, { damping: 1.0, response: 0.35, onUpdate: function(v){
    sign.style.setProperty('--r', v);
    sign.querySelector; // no-op
    sign.style.transform = 'rotate(' + (v * 90) + 'deg)';
  }});

  btn.addEventListener('click', function(){
    open = !open;
    btn.setAttribute('aria-expanded', String(open));
    h.to(open ? inner.offsetHeight : 0);
    f.to(open ? 1 : 0);
    r.to(open ? 1 : 0);
  });
  addEventListener('resize', function(){ if (open) h.to(inner.offsetHeight); });
});

/* Einblenden — nur transform + opacity §11 */
(function(){
  var els = document.querySelectorAll('.ifs-rise');
  if (!('IntersectionObserver' in window)){
    els.forEach(function(e){ e.classList.add('ifs-seen'); }); return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target;
      var s = new Spring(0, { damping: 1.0, response: 0.5, onUpdate: function(v){
        el.style.opacity = v;
        el.style.transform = 'translateY(' + ((1 - v) * 20) + 'px)';
      }});
      el.classList.add('ifs-seen');
      s.to(1);
      io.unobserve(el);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
  els.forEach(function(e){ io.observe(e); });
})();

}

/* Mobiles Menü */
function infintosMenu(){
  var btn = document.getElementById('ifsBurger');
  var sheet = document.getElementById('ifsSheet');
  if (!btn || !sheet || btn.dataset.bound) return;
  btn.dataset.bound = '1';
  var open = false;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function set(v){
    sheet.style.opacity = v;
    sheet.style.transform = 'scale(' + (0.98 + 0.02 * v) + ')';
    if (v <= 0.001 && !open){ sheet.hidden = true; }
  }
  var s = { x: 0, v: 0, target: 0, running: false };
  function run(){
    if (s.running) return; s.running = true;
    var last = performance.now();
    requestAnimationFrame(function step(now){
      var dt = Math.min((now - last) / 1000, 1/30); last = now;
      var w = (2 * Math.PI) / 0.35, d = s.x - s.target;
      s.v += ((-w * w * d) - (2 * 1.0 * w * s.v)) * dt;
      s.x += s.v * dt; set(s.x);
      if (Math.abs(s.x - s.target) < 0.001 && Math.abs(s.v) < 0.002){
        s.x = s.target; s.v = 0; set(s.x); s.running = false; return;
      }
      requestAnimationFrame(step);
    });
  }
  function toggle(){
    open = !open;
    btn.setAttribute('aria-expanded', String(open));
    btn.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    if (open){ sheet.hidden = false; set(0); }
    s.target = open ? 1 : 0;
    if (reduce){ s.x = s.target; s.v = 0; set(s.x); } else { run(); }
  }
  btn.addEventListener('click', toggle);
  sheet.addEventListener('click', function(e){ if (e.target.tagName === 'A' || e.target === sheet) { if (open) toggle(); } });
  addEventListener('keydown', function(e){ if (e.key === 'Escape' && open) toggle(); });
}
document.addEventListener('DOMContentLoaded', infintosMenu);
document.addEventListener('shopify:section:load', infintosMenu);
if (document.readyState !== 'loading') infintosMenu();

/* Header-Slider: automatischer Wechsel, Kreuzblende über opacity */
function infintosSlider(){
  var root = document.querySelector('.ifs-slider');
  var stage = document.getElementById('ifsSlides');
  var dots = document.getElementById('ifsSlideDots');
  if (!root || !stage || root.dataset.bound) return;
  root.dataset.bound = '1';

  var slides = [].slice.call(stage.children);
  if (slides.length === 0) return;
  var i = 0, timer = null;
  var wait = parseInt(root.dataset.interval, 10) || 6000;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  slides.forEach(function(_, n){
    var b = document.createElement('button');
    b.type = 'button'; b.setAttribute('aria-label', 'Folie ' + (n + 1));
    b.addEventListener('click', function(){ show(n); restart(); });
    dots.appendChild(b);
  });

  function show(n){
    i = (n + slides.length) % slides.length;
    slides.forEach(function(s, k){
      s.classList.toggle('is-on', k === i);
      var v = s.querySelector('video');
      if (v){ if (k === i){ var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { v.pause(); } }
    });
    [].forEach.call(dots.children, function(b, k){
      b.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
  }
  function restart(){
    clearInterval(timer);
    if (slides.length > 1) timer = setInterval(function(){ show(i + 1); }, wait);
  }

  show(0);
  if (!reduce) restart();
  /* Autoplay läuft auch weiter, wenn der Mauszeiger über dem Slider liegt.
     Dadurch wechselt der Header zuverlässig automatisch. */
  document.addEventListener('visibilitychange', function(){
    if (document.hidden) clearInterval(timer); else if (!reduce) restart();
  });
}
document.addEventListener('DOMContentLoaded', infintosSlider);
document.addEventListener('shopify:section:load', infintosSlider);
if (document.readyState !== 'loading') infintosSlider();


/* ==================================================================
   KENNZAHLEN — synchrones Hochzählen
================================================================== */
(function(){
  var counters = [].slice.call(document.querySelectorAll('.ifs-count'));
  if (!counters.length) return;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var duration = 1150;

  function parseValue(raw){
    raw = String(raw || '').trim();
    var suffixMatch = raw.match(/([^0-9,.\-]+)$/);
    var suffix = suffixMatch ? suffixMatch[1] : '';
    var numeric = raw.replace(suffix, '').trim();
    var usesComma = numeric.indexOf(',') !== -1;
    var decimals = usesComma
      ? (numeric.split(',')[1] || '').length
      : (numeric.split('.')[1] || '').length;
    var value = parseFloat(numeric.replace(',', '.'));
    if (!isFinite(value)) value = 0;
    return { value:value, decimals:decimals, usesComma:usesComma, suffix:suffix };
  }

  function formatValue(n, meta){
    var txt = n.toFixed(meta.decimals);
    if (meta.usesComma) txt = txt.replace('.', ',');
    return txt + meta.suffix;
  }

  function animate(){
    if (counters[0].dataset.countDone === '1') return;
    counters.forEach(function(el){ el.dataset.countDone = '1'; });

    if (reduce){
      counters.forEach(function(el){ el.textContent = el.dataset.countValue; });
      return;
    }

    var items = counters.map(function(el){
      return { el:el, meta:parseValue(el.dataset.countValue) };
    });

    var start = performance.now();

    function step(now){
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);

      items.forEach(function(item){
        item.el.textContent = formatValue(item.meta.value * eased, item.meta);
      });

      if (t < 1){
        requestAnimationFrame(step);
      } else {
        items.forEach(function(item){
          item.el.textContent = item.el.dataset.countValue;
        });
      }
    }

    requestAnimationFrame(step);
  }

  var section = counters[0].closest('.ifs-facts');
  if (!section || !('IntersectionObserver' in window)){
    animate();
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      animate();
      io.disconnect();
    });
  }, { threshold:0.35 });

  io.observe(section);
})();

document.documentElement.classList.add('ifs-js');
if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', infintosBoot);
else infintosBoot();
document.addEventListener('shopify:section:load', infintosBoot);
